import appConfig from './liveagent_config';
//This code was generated by salesforce and then customized.
//Make sure to redo these changes if you overwrite this with a new snippet.

export const initESW = function(gslbBaseURL) {
  window.embedded_svc.settings.displayHelpButton = true; //Or false
  window.embedded_svc.settings.language = 'de'; //For example, enter 'en' or 'en-US'
  window.embedded_svc.settings.defaultMinimizedText = 'chat mit troy'; //(Defaults to Chat with an Expert)
  window.embedded_svc.settings.disabledMinimizedText = 'chat offline'; //(Defaults to Agent Offline)
  //window.embedded_svc.settings.language = 'en'; //For example, enter 'en' or 'en-US'
  //window.embedded_svc.settings.defaultMinimizedText = 'chat with troy'; //(Defaults to Chat with an Expert)
  //window.embedded_svc.settings.disabledMinimizedText = 'chat offline'; //(Defaults to Agent Offline)

  //window.embedded_svc.settings.loadingText = ''; //(Defaults to Loading)
  //window.embedded_svc.settings.storageDomain = 'yourdomain.com'; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)

  // Settings for Live Agent
  //window.embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
  // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
  // Returns a valid button ID.
  //};
  //window.embedded_svc.settings.prepopulatedPrechatFields = {}; //Sets the auto-population of pre-chat form fields
  //window.embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId
  //window.embedded_svc.settings.offlineSupportMinimizedText = '...'; //(Defaults to Contact Us)

  window.embedded_svc.settings.enabledFeatures = ['LiveAgent'];
  window.embedded_svc.settings.entryFeature = 'LiveAgent';

  window.embedded_svc.init(
    appConfig.salesforce.url,
    appConfig.salesforce.siteUrl,
    gslbBaseURL,
    appConfig.salesforce.organisationId,
    'ChatAgents',
    {
      baseLiveAgentContentURL:
        appConfig.salesforce.baseLiveAgentURL + '/content',
      deploymentId: appConfig.salesforce.deploymentId,
      buttonId: appConfig.salesforce.buttonId,
      baseLiveAgentURL: appConfig.salesforce.baseLiveAgentURL + '/chat',
      eswLiveAgentDevName: 'ChatAgents',
      isOfflineSupportEnabled: false
    }
  );
};
